export default "__VITE_ASSET__DdaefMBT__"